if (customElements.get('video-modal') === undefined) {
  const classes = {
    siteOverflowed: 'util-SiteOverflowed'
  }
  class VideoModal extends HTMLElement {
    constructor () {
      super()

      this.modalTriggerEls = document.querySelectorAll(
        '[data-el="video-modal.modal-trigger"]'
      )

      this.modalCloseEls = this.querySelectorAll(
        '[data-el="video-modal.modal-close"]'
      )

      this.modalVideoEl = this.querySelector(
        '[data-el="video-modal.modal-video"]'
      )

      this.modalVideoSourceEl = this.querySelector(
        '[data-el="video-modal.modal-video-source"]'
      )

      this.modalYouTubeEl = this.querySelector(
        '[data-el="video-modal.modal-youtube"]'
      )

      this.player = ''

      this.setupVideoModal()
    }

    setupVideoModal () {
      if (!this.modalTriggerEls) return

      this.modalTriggerEls.forEach(modalTriggerEl => {
        modalTriggerEl.addEventListener(
          'click',
          this.handleModalTrigger.bind(this)
        )
      })
      this.modalCloseEls.forEach(modalCloseEl => {
        modalCloseEl.addEventListener('click', this.handleModalClose.bind(this))
      })

      this.onYouTubeIframeAPIReady()
    }

    onYouTubeIframeAPIReady () {
      this.player = new YT.Player(this.modalYouTubeEl.id, {
        height: '1080',
        width: '1920',
        videoId: this.modalYouTubeEl.dataset.src,
        playerVars: {
          playsinline: 1,
          modestbranding: 0,
          rel: 0
        }
      })
    }

    handleModalTrigger = e => {
      if (
        this.modalVideoEl &&
        this.dataset.videoModalId === e.currentTarget.dataset.videoModalId
      ) {
        if (!this.modalVideoSourceEl.src) {
          this.modalVideoSourceEl.src = this.modalVideoSourceEl.dataset.src
          this.modalVideoEl.load()
        }

        this.modalVideoEl.play()
        this.setAttribute('aria-hidden', 'false')
        document.body.classList.add(classes.siteOverflowed)
      }

      if (
        this.modalYouTubeEl &&
        this.dataset.videoModalId === e.currentTarget.dataset.videoModalId
      ) {
        this.player.playVideo()
        document.body.classList.add(classes.siteOverflowed)
        this.setAttribute('aria-hidden', 'false')
      }
    }

    handleModalClose = () => {
      if (this.modalVideoEl) {
        this.modalVideoEl.pause()
      }
      if (this.modalYouTubeEl) {
        this.player.pauseVideo()
      }

      this.setAttribute('aria-hidden', 'true')
      document.body.classList.remove(classes.siteOverflowed)
    }
  }

  customElements.define('video-modal', VideoModal)
}
